var React = require('react');

function IconChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9149 18.6683L19.872 6.98521C19.993 6.78224 19.9959 6.53156 19.8797 6.32848C19.7635 6.1254 19.5457 6.00011 19.3085 6L13.8187 6.00033L14.3943 7.31382L18.1429 7.31338L12.3592 17.0259L6.80653 7.3143L11.1476 7.31396L10.572 6.00047L5.6721 6.00125C5.43492 6.00114 5.21425 6.12653 5.09294 6.32965C4.9839 6.51285 4.9706 6.73443 5.05413 6.92505C5.06327 6.94591 5.07372 6.9662 5.08528 6.98638L11.765 18.6684C11.8812 18.8714 12.099 18.9967 12.3362 18.9968C12.5734 18.997 12.7939 18.8712 12.9149 18.6683Z","fill":"black"}));
}

IconChevronDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconChevronDown;

IconChevronDown.default = IconChevronDown;
